import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMonumentoMaggiore10 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 34,
	viewBox: "0 0 28 34",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_d_981_10892)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1 6.5C1 3.73858 3.23858 1.5 6 1.5H20C22.7614 1.5 25 3.73858 25 6.5V20.5C25 23.2614 22.7614 25.5 20 25.5H17.5L13.848 30.3693C13.4341 30.9212 12.5987 30.8981 12.216 30.324L9 25.5H6C3.23858 25.5 1 23.2614 1 20.5V6.5Z",
			fill: "#12AAFF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_981_10892",
		x: 0,
		y: .5,
		width: 28,
		height: 34,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {
				dx: 1,
				dy: 1
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_981_10892"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_981_10892",
				result: "shape"
			})
		]
	}) })]
});
export default SvgMonumentoMaggiore10;
